// Running total of a daily reward series, for the rewards-over-time line.
//
// Rewards land once per epoch (~2 days) while the daily series carries every
// calendar day in range, so about half its points are structural zeros. A
// running total turns those into flat segments rather than holes, and its last
// point is the "Total accumulated" figure above the chart.

/**
 * Accumulates a daily series into a monotonic one of the same length.
 *
 * Non-finite entries are treated as zero: a NaN partway through would otherwise
 * poison the total and blank the rest of the line.
 */
export const toCumulativeSeries = (data: number[]): number[] => {
  let total = 0;

  return data.map((value) => {
    total += Number.isFinite(value) ? value : 0;
    return total;
  });
};
